<template>
  <div v-if="showAdminPreferences">
    <h2>Admin Preferences</h2>
    <Toggle trueLabel="suppress" trueIcon="ban" falseLabel="send" falseIcon="envelope" v-model="suppressReviewEmails">
      <template slot="trueDescription">Suppress</template>
      <template slot="falseDescription">Send</template>
      "needs review" emails
    </Toggle>
  </div>
</template>

<style lang="scss" scoped>
h2 {
  margin-top: 1em;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(['member', 'approvalEnabled']),
    showAdminPreferences() {
      // Only show when there are relevant settings
      return this.member.user_type === 'admin' && this.approvalEnabled;
    },
    suppressReviewEmails: {
      get() {
        return !!(this.member.settings||{}).suppressReviewEmails;
      },
      async set(value) {
        let {id, settings} = this.member;
        if (!settings) settings = {};
        settings.suppressReviewEmails = !!value;
        await this.updateUserProfile({id, settings});
      }
    }
  },
  methods: {
    ...mapActions(['updateUserProfile'])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/AdminPreferences.vue